import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import PageContent from "../shared/PageContent/PageContent";
import TasksCard from "../shared/TasksCard/TasksCard";
import "../Organization/OrganizationPage.css";
import { IconHome, IconCheckbox } from "@tabler/icons-react";

const TABS = [
  { id: "home", label: "Home", icon: IconHome },
  { id: "tasks", label: "Tasks", icon: IconCheckbox },
];

function ReppiAdminDashboard() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState("home");

  const dashboardCustomHeader = (
    <div className="org-page-custom-header">
      <div className="org-page-header-left">
        <h1 className="org-page-main-title">Home</h1>
        <nav className="org-page-nav-tabs" role="tablist">
          {TABS.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                role="tab"
                aria-selected={activeTab === tab.id}
                className={`org-page-nav-tab${activeTab === tab.id ? " active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <Icon size={16} />
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );

  return (
    <PageContent customHeader={dashboardCustomHeader}>
      {activeTab === "home" && (
        <div className="rep-dashboard-container">
          <div className="rep-dashboard-header">
            <div className="rep-dashboard-welcome">
              <h1 className="rep-dashboard-title">
                Welcome back, {user.firstName}! 👋
              </h1>
            </div>
          </div>
        </div>
      )}
      {activeTab === "tasks" && <TasksCard height={600} />}
    </PageContent>
  );
}

export default ReppiAdminDashboard;
